import { Box, styled, Typography, Theme } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import React from "react";
import fastCompare from "react-fast-compare";

export const MIN_RATINGS_AVG = 4.0;

export const MIN_RATINGS_COUNT = 50;

export const RatingTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component: any }) => ({
    fontWeight: 400,
    fontFamily: "Roobert, Arial",
    letterSpacing: 0,
    fontSize: "1.4rem",
    lineHeight: "1.6rem",
    marginLeft: "2px",
    whiteSpace: "nowrap",
    "& strong": {
      fontWeight: 600
    }
  })
);

type Props = {
  rating: { average: number; count: number };
  className?: string;
};

function PodRating({ rating, className }: Props) {
  // Hide rating if under 4.0 stars average and under 50 ratings total
  if (
    !rating ||
    (rating.average <= MIN_RATINGS_AVG && rating.count < MIN_RATINGS_COUNT)
  ) {
    return null;
  }
  return (
    <Box display="flex" alignItems="center" className={className}>
      <StarIcon color="primary" fontSize="small" />
      <RatingTypography component="span">
        <strong>{rating.average.toFixed(1)}</strong> ({rating.count})
      </RatingTypography>
    </Box>
  );
}

export default React.memo(PodRating, fastCompare);
